const route = {
    path: '/profile',
    meta: { authClass: 'protected' },
    children: [
        {
            path: '',
            components: {
                default:
                    () => import(/* webpackChunkName: "profile" */ '../../components/views/users/profile.vue'),
            }
        },
    ],
}

module.exports = route;